// extracted by mini-css-extract-plugin
export var menuIcon = "_ro-0";
export var menuIconInline = "_ro-1";